import { render } from "./List.vue?vue&type=template&id=0c1b65cc&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=0c1b65cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c1b65cc"

export default script